import {
  AuthBody,
  LoginValues,
  TwoFactorLoginValues,
} from '../../models/AuthBody';
import httpClient from 'api/httpClient';
import publicHttpClient from 'api/publicHttpClient';

const authPath = (routePath: TemplateStringsArray) => `auth/${routePath}`;

function login(userData: LoginValues) {
  return publicHttpClient.post<AuthBody>(authPath`login`, userData);
}

function twoFactorLogin(values: TwoFactorLoginValues) {
  return publicHttpClient.post(authPath`login-verify/token`, values);
}

function forgotPasswordRequest(email: string) {
  return publicHttpClient.post(authPath`forgot-password`, { email });
}

function resetPassword(password: string, token: string) {
  return publicHttpClient.post(
    authPath`reset-password`,
    { password },
    { params: { token } },
  );
}

function updatePassword(oldPassword: string, newPassword: string) {
  return httpClient.post(authPath`change-password`, {
    oldPassword,
    newPassword,
  });
}

const refreshToken = (refreshToken: string) => {
  return publicHttpClient.post(`auth/refresh-token`, { refreshToken });
};

export default {
  login,
  twoFactorLogin,
  forgotPasswordRequest,
  resetPassword,
  refreshToken,
  updatePassword,
};
